
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantInput = this.form.querySelector('[name="id"]');

        if (this.variantInput) {
          this.variantInput.disabled = false;
        }

        this.submitButton = this.querySelector('[type="submit"]');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.isSubmitting = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (
          this.isSubmitting ||
          !this.submitButton ||
          this.submitButton.disabled ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const variantId = String(formData.get('id') || '');

        // Confirm that a valid Shopify variant is selected.
        if (!/^\d+$/.test(variantId) || variantId === '0') {
          this.handleErrorMessage(
            'Please select an available product.'
          );
          return;
        }

        this.isSubmitting = true;

        // Prevent double-clicking during checkout navigation.
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-disabled', 'true');

        // Build a Shopify cart permalink.
        // This sends the selected variant directly to checkout
        // without a separate AJAX add-to-cart request.
        const root = window.Shopify?.routes?.root || '/';

        const normalizedRoot = root.endsWith('/')
          ? root
          : root + '/';

        const checkoutUrl =
          normalizedRoot +
          'cart/' +
          encodeURIComponent(variantId) +
          ':1';

        // Navigate immediately.
        window.location.assign(checkoutUrl);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
